import React, { useState } from "react";
import CharacterSelection from "./components/CharacterSelection";
import GameBoard from "./components/GameBoard";

function App() {
  const [playerInfo, setPlayerInfo] = useState(null);

  const handleCharacterSelect = (info) => {
    setPlayerInfo(info);
  };

  const handleQuit = () => {
    setPlayerInfo(null);
  };

  return (
    <div>
      {!playerInfo ? (
        <CharacterSelection onCharacterSelect={handleCharacterSelect} />
      ) : (
        <GameBoard
          playerCharacter={playerInfo.character}
          playerName={playerInfo.name}
          onQuit={handleQuit}
        />
      )}
    </div>
  );
}

export default App;